import { CookiesControllerState } from "~/domain/interfaces/CookiesStateTypes";

const cookiesControllerState: CookiesControllerState = {
  isBannerVisible: true,
  cookies: null
}

export default () => cookiesControllerState